export class RootSchema {
}
export class SerializrAttributeContext {
    constructor(init) {
        Object.assign(this, init);
    }
    propName;
    attrName;
    objectContext;
}
